const searchTrigger = document.querySelector('.search-trigger');
const closeOverlay = document.querySelector('.close-overlay');
const mainContentElm = document.getElementById('MainContent');

searchTrigger.addEventListener('click', function () {
    if (!mainContentElm.classList.contains('search-active')) {
        mainContentElm.classList.add('search-active');
    }
});
closeOverlay.addEventListener('click', function () {
    if (mainContentElm.classList.contains('search-active')) {
        mainContentElm.classList.remove('search-active');
    }
});